// extracted by mini-css-extract-plugin
module.exports = {"active":"BurgerMenu_active__HvHAX","container":"BurgerMenu_container__mF1zR","content":"BurgerMenu_content__jaWJS","signin":"BurgerMenu_signin__uO0jY"};